import React from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import MantraSection from '../components/MantraSection';
import WhatIsKompaSection from '../components/WhatIsKompaSection';
import SavingsModalitiesSection from '../components/SavingsModalitiesSection';
import PlansSection from '../components/PlansSection';
import FAQSection from '../components/FAQSection';
import FloatingCTA from '../components/FloatingCTA';

const Home = ({ scrollToSection }) => {
  return (
    <>
      <SEO pathname="/" />
      <HeroSection scrollToSection={scrollToSection} />
      <MantraSection scrollToSection={scrollToSection} />
      <WhatIsKompaSection />
      <SavingsModalitiesSection />
      <PlansSection />
      <FAQSection />
      <FloatingCTA />
    </>
  );
};

export default Home;
